import './styles/vendor/bootstrap.css';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import {prefetchWhenIdle} from '@/helpers/lazyLoad';
import store from './store';
import { i18n } from './lang';
import InlineSvg from 'vue-inline-svg';
import Vue3Toastify, { toast } from 'vue3-toastify';
import PrimeVue from 'primevue/config';
import 'vue3-toastify/dist/index.css';
import Tooltip from 'primevue/tooltip';

import './styles/main.scss';

declare global {
    interface String {
        /**
         * Check if the string is blank or null
         */
        isBlank(): boolean;
    }
}

String.prototype.isBlank = function (this: string) {
    return !this || /^\s*$/.test(this);
};

const globalMixin = {
    computed: {
        canShowTableIds(this: any) {
            return this.$store?.state?.account?.isSuperUser === true
                && this.$store?.state?.preferences?.values?.showTableIds === true;
        },
        isAdminUser(this: any) {
            const type = this.$store?.state?.account?.user?.type;
            return type === "ADMIN" || type === "SUPER_USER";
        },
        canDeleteRecords(this: any) {
            return this.isAdminUser;
        }
    },
    methods: {
        isPhone(this: any) {
            return window.innerWidth < 768;
        },
        isBlackbox() {
            return process.env.VUE_APP_CERTIFIED === "true";
        }
    },
};

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Vue3Toastify, {
    autoClose: 1500,
    transition: toast.TRANSITIONS.SLIDE,
    position: toast.POSITION.TOP_RIGHT,
    limit: 4,
    hideProgressBar: true,
    icon: false,
});
appInstance.use(store);
appInstance.use(i18n);
appInstance.use(PrimeVue);
appInstance.directive('tooltip', Tooltip);
appInstance.component('inline-svg', InlineSvg);
appInstance.mixin(globalMixin);
appInstance.mount('#app');
router.isReady().then(prefetchWhenIdle).catch(() => null);
